/**
 * Warstwa API: OSOBY WNIOSKU HR — kandydaci do pola wyboru osoby (np. „Zastępstwo na czas nieobecności”).
 *
 * [polecenie właściciela 2026-09-30, A] „zastępcę wybieram w obrębie całego działu, działu nie po wszystkich
 * ludziach z aplikacji — dotyczy to składanych wniosków”.
 *
 * Trasa backendu: `GET api/hr-requests/substitute-candidates` z parametrami:
 *  - `typeCode` + `field` — serwer czyta ZAKRES z definicji pola (w dziale / poza działem / spółka);
 *    zakresu NIE wysyłamy, bo serwer i tak go nie przyjmie (każdy dopisałby sobie „cała spółka”),
 *  - `search` — fraza (imię, nazwisko, stanowisko),
 *  - `forUserId` — wniosek „w imieniu” (bramka kadr / przełożonego po stronie serwera),
 *  - `requestId` — korekta wniosku (zakres z zamrożonej definicji wniosku),
 *  - `assignmentId` — wniosek ze ZLECENIA KADR: osoba wniosku pochodzi ze zlecenia (ta sama reguła, co przy
 *    składaniu), więc adresat zlecenia spoza zasięgu pracownika też dostaje listę.
 * Odpowiedź: `{ dzial, osoby: [{ id, name, position, unit }], obcieto, zakres, zakresListy }` — dział = korzeń
 * gałęzi osoby wniosku razem z komórkami, limit 50 (obcieto = „wpisz nazwisko, aby zawęzić”); `zakres` = zakres
 * pola z definicji (decyduje o wpisie ręcznym), `zakresListy` = zakres, którym faktycznie policzono listę.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do
 * wspólnego `apiService`. Nazwy muszą być unikalne w całej aplikacji (patrz attachApiModules).
 */
export function attach(api) {
    return {
        getHrPersonCandidates: ({ typeCode, field, search, forUserId, requestId, assignmentId } = {}) => {
            const params = {};
            if (typeCode) params.typeCode = typeCode;
            if (field) params.field = field;
            if (search) params.search = search;
            if (forUserId) params.forUserId = forUserId;
            if (requestId) params.requestId = requestId;
            if (assignmentId) params.assignmentId = assignmentId;
            return api.get("/hr-requests/substitute-candidates", { params });
        },
    };
}
